import { Star, Quote } from "lucide-react";

const SocialProof = () => {
  const metrics = [
    {
      value: "74%",
      label: "Average occupancy across managed properties",
    },
    {
      value: "$350+",
      label: "Average monthly revenue uplift after listing audit",
    },
    {
      value: "100%",
      label: "5-star review rate across all managed properties",
    },
  ];

  const testimonials = [
    {
      quote:
        "Within two weeks of the listing audit our bookings doubled. The title and description changes alone made a huge difference.",
      author: "Sarah M.",
      location: "Woorim",
    },
    {
      quote:
        "I was sceptical about letting someone else manage my property but the communication and results have been outstanding.",
      author: "David K.",
      location: "Bongaree",
    },
  ];

  return (
    <section
      id="social-proof"
      data-testid="social-proof-section"
      className="section-padding bg-white"
    >
      <div className="container-custom">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-xs uppercase tracking-[0.2em] text-gold font-semibold mb-4">
            Our Track Record
          </p>
          <h2 className="section-heading">Results that speak for themselves</h2>
        </div>

        {/* Metrics */}
        <div className="grid md:grid-cols-3 gap-8 lg:gap-16 mb-20">
          {metrics.map((metric, index) => (
            <div
              key={index}
              className="text-center"
              data-testid={`metric-${index}`}
            >
              <div className="metric-number">{metric.value}</div>
              <p className="metric-label">{metric.label}</p>
            </div>
          ))}
        </div>

        {/* Testimonials */}
        <div className="grid md:grid-cols-2 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-cream p-8 lg:p-10 relative"
              data-testid={`testimonial-${index}`}
            >
              {/* Quote Icon */}
              <Quote className="absolute top-6 right-6 w-10 h-10 text-gold/20" />

              {/* Stars */}
              <div className="flex gap-1 mb-6">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    size={18}
                    className="fill-gold text-gold"
                  />
                ))}
              </div>

              {/* Quote */}
              <blockquote className="text-lg text-bark leading-relaxed mb-6 font-serif italic">
                "{testimonial.quote}"
              </blockquote>

              {/* Author */}
              <div className="flex items-center gap-2">
                <span className="w-8 h-px bg-gold" />
                <span className="text-sm font-semibold text-bark">
                  {testimonial.author}
                </span>
                <span className="text-sm text-bark-light">
                  {testimonial.location}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
